export function getMonth(month) {
    const lastIndex = month.length - 1;
    return month[lastIndex] === 'т' ? `${month}а` : `${month.split('').slice(0, lastIndex).join('')}я`;
}